import { COOKIE_KEYS } from "../constants"

/**
 * 从 cookies 获取 token
 * @returns token 或 undefined
 */
export async function getTokenFromCookies(): Promise<string | undefined> {
  const { cookies } = await import("next/headers")
  const cookieStore = await cookies()
  return process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY
    ? cookieStore.get(process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY)?.value
    : undefined
}

/**
 * 获取已关闭的公告 ID
 * @returns 已关闭的公告 ID 或 null
 */
export async function getClosedAnnouncementId(): Promise<string | null> {
  const { cookies } = await import("next/headers")
  const cookieStore = await cookies()
  return cookieStore.get(COOKIE_KEYS.ANNOUNCEMENT_BANNER_CLOSED_ID)?.value || null
}
